import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';

// Mui
import { Box, TextField, Grid, Modal, Divider, Typography, IconButton, Button, Icon, Tooltip } from '@mui/material';
import { Close } from '@mui/icons-material';
import { red } from '@mui/material/colors';

// Components
import UploadSingleFile from '@components/Files/UploadSingleFile';
import AdvancedSelect from "@components/Selects/AdvancedSelect";

// Validations
import { BannerPPM, socialNetworks } from '@data/schemas/ppmSchema';
import { BannerInterface, socialNetworksInterface } from '@data/interfaces/ppmInterface';

// Data
import { socialNetworksData } from '@data/constants/Ppm';

const FormBanners = (props) => {
    const {
        setModalOpen,
        modalOpen,
        params = {},
        title = 'Actualización de información',
        setData
    } = props;

    const [social, setSocial] = useState(null)

    const formik = useFormik({
        initialValues: BannerInterface,
        validationSchema: BannerPPM,
        enableReinitialize: false,
        validateOnChange: true,
        onSubmit: (values, actions) => {
            setData(values);
        }
    });

    const resetParams = () => {
        formik.resetForm();
        setModalOpen(false);
    };

    const handleEditModalClose = () => {
        setModalOpen(false);
    };

    const handleFiles = (e) => {
        formik.setFieldValue("files", [{ file: e }]);
        formik.setFieldTouched("files", true, false); // Marcar como tocado
    };


    useEffect(() => {
        if (Object.keys(params).length > 0) {
            formik.setValues({
                id: params.id || '',
                title: params.title || '',
                description: params.description || '',
                files: [{ file: params.imagePath }],
                socialNetworks: params.redesSociales || [],
                comparar: params.imagePath
            });
        }
        //eslint-disable-next-line
    }, [params]);

    const addSocialNetwork = (newEducation) => {
        const newData = [...formik.values.socialNetworks, newEducation];
        formik.setFieldValue("socialNetworks", newData, true);
        formikEducation.resetForm();
        setSocial(null);  // Reiniciar el estado del icono social de textfield
    };

    const removeSocialNetwork = (index) => {
        const updated = formik.values.socialNetworks.filter((_, i) => i !== index);
        formik.setFieldValue("socialNetworks", updated);
    };

    const formikEducation = useFormik({
        initialValues: socialNetworksInterface,
        validationSchema: socialNetworks,
        onSubmit: (values) => {
            addSocialNetwork(values)
        },
    });

    const socialNetworksOptions = socialNetworksData.map(({ id, label }) => ({ value: id, label }))
    // Funcion para cambiar por props si iconos van de color blanco o por defecto de consts
    const getIconById = (id, isWhite = false) => {
        const icon = socialNetworksData.find(item => item.id === id)?.icon;

        if (!icon) return null;

        // Clonamos el ícono para agregarle el color blanco si `isWhite` es true
        return React.cloneElement(icon, {
            style: { ...icon.props.style, color: isWhite ? '#fff' : icon.props.style.color }
        });
    };

    const getPlaceholderById = (id) => socialNetworksData.find(item => item.id === id)?.placeholder;
    const getName = (id) => socialNetworksData.find(item => item.id === id)?.label;

    return (
        <Modal
            open={modalOpen}
            disableEscapeKeyDown
            aria-labelledby="modal-edit-title"
            aria-describedby="modal-edit-description"
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '90%',
                    height: '90%',
                    maxWidth: 1100,
                    bgcolor: 'background.paper',
                    borderRadius: 4,
                    boxShadow: 24,
                    p: 4,
                    overflowY: 'auto'
                }}
            >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography id="modal-edit-title" variant="h6" component="h2">
                        {title}
                    </Typography>
                    <Tooltip title="Cerrar">
                        <IconButton onClick={handleEditModalClose}>
                            <Close />
                        </IconButton>
                    </Tooltip>
                </Box>
                <Divider />
                <Grid container spacing={2} sx={{ mt: 1 }}>
                    <Grid item xs={12} sm={12} md={6}>
                        <TextField
                            id="title"
                            variant="outlined"
                            label="Título"
                            size="small"
                            sx={{ width: '100%' }}
                            value={formik.values.title}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={Boolean(formik.errors.title) && formik.touched.title}
                            helperText={formik.touched.title && formik.errors.title ? formik.errors.title : ''}
                        />
                    </Grid>

                    <Grid item xs={12} sx={12} md={6}>
                        <TextField
                            id='description'
                            size="small"
                            fullWidth
                            name="description"
                            label="Descripción"
                            placeholder="Síguenos en nuestra campaña..."
                            value={formik.values.description}
                            onChange={formik.handleChange}
                            // disabled={loadAll}
                            onBlur={formik.handleBlur}
                            error={Boolean(formik.errors.description) && formik.touched.description}
                            helperText={formik.touched.description && formik.errors.description ? formik.errors.description : ''}
                            multiline
                            minRows={3}
                        />
                    </Grid>

                    <LocalDivider />

                    {/* Nombre de la red social */}
                    <Grid item xs={12} md={6}>
                        <AdvancedSelect
                            size="small"
                            label="Medio de Difusión"
                            name="socialNetworksType"
                            options={socialNetworksOptions}
                            value={formikEducation.values.socialNetworksType}
                            onChange={(e) => {
                                formikEducation.setFieldValue("socialNetworksType", e.value)
                                setSocial(e.value)
                                formikEducation.setFieldValue("socialNetworksLink", "");
                            }
                            }
                            error={formikEducation.touched.socialNetworksType && Boolean(formikEducation.errors.socialNetworksType)}
                            helperText={formikEducation.touched.socialNetworksType && formikEducation.errors.socialNetworksType}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            id='socialNetworksLink'
                            size="small"
                            label="Link Medio de Difusión"
                            placeholder={getPlaceholderById(social) || null}
                            name="socialNetworksLink"
                            value={formikEducation.values.socialNetworksLink}
                            onChange={formikEducation.handleChange}
                            error={formikEducation.touched.socialNetworksLink && Boolean(formikEducation.errors.socialNetworksLink)}
                            helperText={formikEducation.touched.socialNetworksLink && formikEducation.errors.socialNetworksLink}
                            fullWidth
                            InputProps={{
                                startAdornment: formikEducation.values.socialNetworksType ? (
                                    <Box sx={{ mr: '8px', mt: 1 }}>
                                        {getIconById(formikEducation.values.socialNetworksType) || null}
                                    </Box>
                                ) : null,
                            }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={12} md={6}>
                        <TextField
                            id="textButton"
                            variant="outlined"
                            label="Texto en Botón"
                            size="small"
                            fullWidth
                            value={formikEducation.values.textButton}
                            onChange={formikEducation.handleChange}
                            onBlur={formikEducation.handleBlur}
                            error={Boolean(formikEducation.errors.textButton) && formikEducation.touched.textButton}
                            helperText={formikEducation.touched.textButton && formikEducation.errors.textButton ? formikEducation.errors.textButton : ''}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <Button color="primary" variant="outlined" fullWidth onClick={formikEducation.handleSubmit}>
                            Agregar Medio de Difusión
                        </Button>
                    </Grid>

                    {formik?.values?.socialNetworks?.map((item, index) => (

                        <Grid
                            item
                            xs={12}
                            md={6}
                            lg={4}
                            key={index}
                            sx={{
                                position: 'relative',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center'
                            }}
                            gap={2}
                        >
                            <Typography sx={{ fontWeight: 600 }}>
                                {getName(item.socialNetworksType)}
                            </Typography>
                            <Box sx={{ position: 'relative', width: '100%' }}>
                                <Button
                                    key={index}
                                    startIcon={getIconById(item.socialNetworksType, true)}
                                    variant="contained"
                                    href={item.socialNetworksLink}
                                    target="_blank"
                                    sx={{
                                        overflow: "hidden",
                                        height: { xs: 28, lg: 40 },
                                        width: '100%',
                                        borderRadius: "30px",
                                        fontSize: 20,
                                        fontWeight: 600,
                                        textTransform: "none",
                                        color: "#fff",
                                        cursor: "pointer",
                                        background: "linear-gradient(90deg, #03a9f4,rgb(65, 110, 244),rgb(91, 67, 229),rgba(67, 31, 152, 0.8), rgb(67, 48, 172), rgb(65, 110, 244), #03a9f4)",
                                        backgroundSize: "400%",
                                        transition: "0.5s",
                                        "&:hover": {
                                            animation: "animate 8s linear infinite",
                                            color: "#fff",
                                        },
                                        "&:focus": {
                                            color: "#fff",
                                        },
                                        "&.Mui-focusVisible": {
                                            color: "#fff",
                                        }
                                    }}
                                >
                                    {item.textButton || "Ver más"}
                                </Button>

                                <IconButton
                                    onClick={() => removeSocialNetwork(index)}
                                    sx={{
                                        position: 'absolute',
                                        top: '-8px',
                                        right: '-8px',
                                        backgroundColor: '#f44336',
                                        color: '#fff',
                                        width: 24,
                                        height: 24,
                                        '&:hover': { backgroundColor: '#d32f2f' }
                                    }}
                                >
                                    <Icon>close</Icon>
                                </IconButton>
                            </Box>
                        </Grid>
                    ))}

                    <LocalDivider />

                    <Grid container spacing={2} mt={2} justifyContent="center">
                        <Grid item xs={8}>
                            <UploadSingleFile
                                file={
                                    formik.values.files && formik.values.files.length > 0
                                        ? formik.values.files[0].file
                                        : params.imagePath
                                }
                                setFile={handleFiles}
                                accept="image/*"
                            />

                            {formik.touched.files && formik.errors?.files?.length > 0 && formik.errors.files[0]?.file && (
                                <Typography color="error">{formik.errors.files[0].file}</Typography>
                            )}
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} mt={2} justifyContent="center">
                        <Grid item>
                            <Button
                                variant="contained"
                                size="small"
                                onClick={resetParams}
                                style={{ backgroundColor: red[600], color: '#fff' }}
                            >
                                Cancelar
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button variant="contained" color="primaryDark" size="small" onClick={formik.submitForm}>
                                Guardar
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </Modal>
    );
};

const LocalDivider = () => (
    <Grid item xs={12}>
        <Divider
            sx={{
                borderStyle: "none",
                height: "2px",
                background:
                    "repeating-linear-gradient(90deg, rgba(0, 0, 0, 0.12), rgba(0, 0, 0, 0.12) 10px, transparent 10px, transparent 20px)",
                my: 3,
            }}
        />
    </Grid>
);

export default FormBanners;
